import * as React from 'react';
import '../Modals.css';
import Modal from 'src/modules/commons/modal-handler/jQueryModal';
import SelectContainer from 'src/modules/commons/inputs/select/Select.container';
import InputContainer from 'src/modules/commons/inputs/input/Input.container';
import ErrorMessagesComponent from 'src/modules/commons/error-messages/ErrorMessages.component';

export interface ModifyContractsComponentProps {
  handleSubmit: () => void;
  handleChange: (key: string) => ((value: string | boolean | File) => void);
  modalRef?: Modal;
  optionTypes: { name: string, value: string }[];
  typeError: string;
  errorDescription: string;
  errorMessage: {};
}

const ModifyContractsComponent: React.StatelessComponent<ModifyContractsComponentProps> =
  (props: ModifyContractsComponentProps) => (
    <div className="modal-content">
      <div className="modal-header">
        <p className="text-right">
        <span
          className="close-med pointer"
          onClick={() => props.modalRef!.modal('hide')}
        />
        </p>
        <img
          src="/img/the-crowd-angel.png"
          alt="logo"
        />
        <div className="gap-20"/>
        <hr/>
      </div>
      <div className="modal-body">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            props.handleSubmit();
          }}
        >
          <h4 className="">
            <strong>¿Dónde has encontrado la errata?</strong>
          </h4>
          <div className="gap-20"/>
          <div>
            Indícanos en que apartado has encontrado la errata y cúal debería ser el texto correcto.
          </div>
          <div className="gap-30"/>
              <SelectContainer
                label="La errata está en:"
                value={props.typeError}
                handleChange={props.handleChange('typeError')}
                addEmptyOption={false}
                itemSet={props.optionTypes}
                width={'col-md-6'}
              />
            <div className="col">
              <InputContainer
                label=" "
                type="textarea"
                placeholder="Mensaje..."
                value={props.errorDescription}
                onChange={props.handleChange('errorDescription')}
              />
            </div>
          <div className="gap-20" />
          <ErrorMessagesComponent
            errorMessage={props.errorMessage}
          />
          <div className="gap-20"/>
          <div className="text-right">
            <button
              type="submit"
              className="btn btn-secondary text-right"
            >
              Actualizar
            </button>
            <div className="gap-20"/>
          </div>
        </form>
      </div>
    </div>
  );

export default ModifyContractsComponent;



// WEBPACK FOOTER //
// ./src/modules/modals/modify-contracts/ModifyContracts.component.tsx